"use client";

import { createContext, useContext, ReactNode } from 'react';
import type { AccessControl } from '@/lib/firebase';
import type { Document } from '@/types';

interface AssistantConfig {
  assistantId: string;
  name: string;
  avatar: string;
  initialMessage: string;
  initialInstructions: string;
  initialDocuments: Document[];
  tools: string[];
  toolConfigs: Record<string, Record<string, any>>;
  templateId?: string;
  accessControl?: AccessControl;
  adminEmail?: string;
  senderName?: string;
}

interface AssistantContextType {
  config: AssistantConfig;
}

const AssistantContext = createContext<AssistantContextType | null>(null);

export const useAssistant = () => {
  const context = useContext(AssistantContext);
  if (!context) {
    throw new Error('useAssistant must be used within AssistantProvider');
  }
  return context;
};

interface AssistantProviderProps {
  children: ReactNode;
  config: AssistantConfig;
}

export const AssistantProvider: React.FC<AssistantProviderProps> = ({ 
  children, 
  config 
}) => {
  return (
    <AssistantContext.Provider value={{ config }}>
      {children}
    </AssistantContext.Provider>
  );
};